import { useChatsLinkAnalytics, useChatsLinkForUnauthorized, useChatsLinkReplace } from './hooks';

/**
 * @description
 * Набор хуков для обработки перехода по ссылке /new-chat/
 */
export const ChatsLinkActions = () => {
  useChatsLinkAnalytics();
  useChatsLinkForUnauthorized();
  useChatsLinkReplace();

  return null;
};
